const corporateRiderInvitationActions = {
	INVITE_EXISTING_RIDER: 'INVITE_EXISTING_RIDER',
	CREATE_RIDER_REQUIRED: 'CREATE_RIDER_REQUIRED',
	RIDER_PENDING_APPROVAL: 'RIDER_PENDING_APPROVAL',
	RIDER_NOT_APPROVED: 'RIDER_NOT_APPROVED',
};

export default corporateRiderInvitationActions;
